export default __webpack_public_path__ + "static/media/Curvet7.3.4514f98d.svg";